import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../../config/siteConfig";
import classNames from "../common/classNames";

const AnnouncementBar = ({ message = siteConfig.announcement, href, className }) => {
  const content = Array.isArray(message) ? message[0] : message;
  if (!content) return null;

  return (
    <aside className={classNames("announcement-bar", className)} aria-label="Store announcement">
      <div className="site-container announcement-bar__inner">
        {href ? <Link to={href}>{content}</Link> : <p>{content}</p>}
      </div>
    </aside>
  );
};

export default AnnouncementBar;
